import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "../../../../components/ui/accordion";
import { Button } from "../../../../components/ui/button";
import { Link } from "react-router-dom";

const JoinProcess: React.FC = () => {
	const steps = [
		{
			id: "register",
			title: "1. 会員登録",
			content:
				"Webサイトから基本情報を入力して会員登録を行います。メールアドレスの確認が必要です。",
		},
		{
			id: "orientation",
			title: "2. オリエンテーション参加",
			content:
				"月1回開催されるオリエンテーションに参加し、学習ギルドの活動内容や利用方法について説明を受けます。",
		},
		{
			id: "interview",
			title: "3. 個別面談（任意）",
			content:
				"希望者は学習プランの相談や目標設定のための個別面談を受けることができます。",
		},
		{
			id: "start",
			title: "4. 活動開始",
			content:
				"各種イベントへの参加や学習スペースの利用が可能になります。まずは気軽なイベントから参加することをお勧めします。",
		},
	];

	return (
		<section className="mb-16">
			<h2 className="text-3xl font-semibold mb-6">参加方法と費用</h2>
			<div className="grid md:grid-cols-2 gap-8">
				<div>
					<h3 className="text-xl font-semibold mb-4">参加までの流れ</h3>
					<Accordion type="single" collapsible className="w-full">
						{steps.map((step) => (
							<AccordionItem key={step.id} value={step.id}>
								<AccordionTrigger>{step.title}</AccordionTrigger>
								<AccordionContent>{step.content}</AccordionContent>
							</AccordionItem>
						))}
					</Accordion>
				</div>
				<div>
					<h3 className="text-xl font-semibold mb-4">費用について</h3>
					<div className="bg-gray-50 p-6 rounded-lg">
						<ul className="space-y-4">
							<li>
								<span className="font-medium">基本利用料：</span>無料
							</li>
							<li>
								<span className="font-medium">特別イベント参加費：</span>
								イベントにより異なる（500円〜2,000円程度）
							</li>
							<li>
								<span className="font-medium">教材費：</span>
								実費（必要な場合のみ）
							</li>
						</ul>
						<div className="mt-8 flex justify-center">
							<Button asChild>
								<Link to="/signup">メンバーになる</Link>
							</Button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default JoinProcess;
